
require('./onEvent');
require('./syncUrlWithScope');
require('./sentry');


module.exports = angular.module('kathondvla.angular.shared.utils', 
    [
        'onEventModule',
        'syncUrlWithScopeModule',
        'sentry'
    ]);